// AbMapActionsBar — Aktionsleiste (KI-Vorschlag / Vorschau / Speichern & aktivieren / Als Entwurf
// speichern) + Status-Banner (KI-Laufzeit, Fehler). Reine Praesentationskomponente — der State
// (Polling, Save-Flow) lebt in AbMappingEditor.js (Single Source of Truth). isAdmin wird NICHT
// mehr hier geprueft: der gesamte Editor ist bereits admin-only gegated (AbMappingEditor zeigt
// Nicht-Admins nur den Hinweis aus ab.map.adminOnlyHint statt der Aktionsleiste, s. Bauplan Punkt 4).

import React from 'react';
import { Sparkles, PlayCircle, Save, FileEdit, Loader2, AlertTriangle, XCircle } from 'lucide-react';
import { btnPrimary, btnGhost } from '../components/ui';

const AbMapActionsBar = ({
  isDarkMode, t,
  aiPhase, aiMsg, aiError, aiDraftActive, onAiSuggest, onDiscardAi,
  previewBusy, previewError, onPreview,
  saving, savingKind, onSaveActivate, onSaveDraft,
  testDocumentId, isDirty,
}) => {
  const aiBusy = aiPhase === 'starting' || aiPhase === 'running';
  const busyAny = aiBusy || previewBusy || saving;
  // Dirty-Check (RULES: kein No-op-Save) — Speichern-Buttons bleiben deaktiviert, solange sich am
  // Formular nichts gegenueber dem zuletzt geladenen/gespeicherten Stand geaendert hat.
  const saveDisabled = busyAny || !isDirty;

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-2 flex-wrap">
        <button type="button" onClick={onAiSuggest} disabled={busyAny || !testDocumentId} className={btnGhost(isDarkMode)}>
          <span className="flex items-center gap-2">
            {aiBusy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Sparkles className="w-4 h-4" />}
            {aiBusy ? t('ab.map.aiSuggestRunning') : t('ab.map.aiSuggestButton')}
          </span>
        </button>
        <button type="button" onClick={onPreview} disabled={busyAny || !testDocumentId} className={btnGhost(isDarkMode)}>
          <span className="flex items-center gap-2">
            {previewBusy ? <Loader2 className="w-4 h-4 animate-spin" /> : <PlayCircle className="w-4 h-4" />}
            {previewBusy ? t('ab.map.previewRunning') : t('ab.map.previewButton')}
          </span>
        </button>
        <button type="button" onClick={onSaveActivate} disabled={saveDisabled} className={btnPrimary(isDarkMode)}>
          <span className="flex items-center gap-2">
            {saving && savingKind === 'activate' ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />}
            {saving && savingKind === 'activate' ? t('ab.map.saveActivateRunning') : t('ab.map.saveActivateButton')}
          </span>
        </button>
        <button type="button" onClick={onSaveDraft} disabled={saveDisabled} className={btnGhost(isDarkMode)}>
          <span className="flex items-center gap-2">
            {saving && savingKind === 'draft' ? <Loader2 className="w-4 h-4 animate-spin" /> : <FileEdit className="w-4 h-4" />}
            {saving && savingKind === 'draft' ? t('ab.map.saveDraftRunning') : t('ab.map.saveDraftButton')}
          </span>
        </button>
        {aiDraftActive && (
          <button type="button" onClick={onDiscardAi} disabled={saving} className={btnGhost(isDarkMode)}>
            {t('ab.map.aiSuggestDiscard')}
          </button>
        )}
      </div>

      {aiPhase === 'not_configured' && (
        <p className={`text-sm flex items-start gap-2 ${isDarkMode ? 'text-amber-300' : 'text-amber-600'}`}>
          <AlertTriangle className="w-4 h-4 flex-shrink-0 mt-0.5" />{t('ab.map.aiSuggestNotConfigured')}
        </p>
      )}
      {aiPhase === 'error' && aiError && (
        <p className={`text-sm flex items-start gap-2 ${isDarkMode ? 'text-red-300' : 'text-red-600'}`}>
          <XCircle className="w-4 h-4 flex-shrink-0 mt-0.5" />{aiError}
        </p>
      )}
      {aiMsg && (
        <p className={`text-sm px-3 py-2 rounded-lg ${isDarkMode ? 'bg-indigo-500/15 text-indigo-200' : 'bg-indigo-50 text-indigo-700'}`}>{aiMsg}</p>
      )}
      {previewError && (
        <p className={`text-sm ${isDarkMode ? 'text-red-300' : 'text-red-600'}`}>{t('ab.map.previewError')}: {previewError}</p>
      )}
    </div>
  );
};

export default AbMapActionsBar;
